import * as React from 'react';

import styled from 'styled-components';

import { COLOR, FONT, FONT_SIZE, SPACING } from '../../packages/constants';
import { ChevronRight } from '../../packages/icons';

export interface CollapsibleBandProps {
    heading: React.ReactNode;
    rightColumn?: React.ReactNode;
    dataId: string;
    onClick?: () => void;
    expand: boolean;
    theme?: {
        main: string;
    };
    className?: string;
}

interface StyledChevronProps {
    isExpanded: boolean;
}

interface StyledHeadingProps {
    isExpanded: boolean;
    theme?: {
        main: string;
    };
}

const StyledCollapsibleBand = styled.div`
    display: flex;
    border-top: 1px solid;
    border-bottom: 1px solid;
    border-color: ${COLOR.MAIN.MEDIUM_GREY};
    align-items: center;
`;

const StyledButton = styled.button`
    flex-grow: 1;
    border: 0;
    padding: 10px;
    cursor: pointer;
    text-align: left;
    background-color: transparent;
`;

const StyledChevron = styled(ChevronRight)<StyledChevronProps>`
    display: inline-block;
    margin-top: -2px;
    margin-right: 6px;
    vertical-align: text-top;
    width: 12px;
    height: 12px;
    fill: ${COLOR.MAIN.DARK_GREY};
    margin-right: ${SPACING.X_SMALL};
    transform: ${(props: StyledChevronProps): string => (props.isExpanded ? 'rotate(-90deg)' : 'rotate(90deg)')};
`;

const StyledHeading = styled.p`
    display: inline-block;
    font-family: ${FONT.OPEN_SANS};
    font-size: ${FONT_SIZE.LARGE};
    font-weight: 700;
    line-height: 1.2;
    color: ${(props: StyledHeadingProps): string =>
        props.isExpanded ? (props.theme ? props.theme.main : COLOR.BRAND.REPORTING) : COLOR.MAIN.DARK_GREY};
`;

const RightColumnContainer = styled.div`
    padding: 10px;
`;

const CollapsibleBand = React.forwardRef<HTMLDivElement, CollapsibleBandProps>(
    ({ heading, rightColumn, expand = false, dataId, onClick, ...props }, ref) => {
        return (
            <StyledCollapsibleBand ref={ref} {...props} data-test-id={`${dataId}`}>
                <StyledButton
                    type="button"
                    data-test-id={`${dataId}-toggle-button`}
                    onClick={onClick}
                    aria-expanded={expand}
                >
                    <StyledChevron isExpanded={expand} aria-hidden="true" />
                    <StyledHeading isExpanded={expand} data-test-id={`${dataId}__heading`}>
                        {heading}
                    </StyledHeading>
                </StyledButton>
                {rightColumn && <RightColumnContainer>{rightColumn}</RightColumnContainer>}
            </StyledCollapsibleBand>
        );
    },
);
CollapsibleBand.displayName = 'CollapsibleBand';

export default CollapsibleBand;
